var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    { staticClass: "pa-0", attrs: { cols: "12" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "span",
                [
                  _vm._v(_vm._s(_vm.titleLabel || "Наименование") + " * ("),
                  _c("TranslationIcon"),
                  _vm._v(")"),
                ],
                1
              ),
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  id: _vm.idTitle,
                  autofocus: !_vm.title && _vm.autofocusEnabled,
                  "error-messages": _vm.titleError,
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.title,
                },
                on: {
                  input: function ($event) {
                    _vm.$emit("change:title", $event.trim())
                  },
                },
              }),
              _vm.isSlugEnabled
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: !_vm.title,
                        "x-small": "",
                        outlined: "",
                        color: "primary",
                      },
                      on: { click: _vm.updateSlugHandler },
                    },
                    [_vm._v(" Сформировать SLUG ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm.isSlugEnabled
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.slugLabel || "Уникальное имя для URL") + " *"
                    ),
                  ]),
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      id: "slug",
                      "error-messages": _vm.slugError,
                      disabled: _vm.isLoading,
                      loading: _vm.isLoading,
                      value: _vm.slug,
                    },
                    on: {
                      change: function ($event) {
                        _vm.$emit("change:slug", $event.trim())
                      },
                      input: function ($event) {
                        return _vm.$emit("input:slug", $event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }